import React from "react";
import { default as MUICardContent } from "@mui/material/CardContent";
import styled from "styled-components";

const StyledMUICardContent = styled(MUICardContent)``;

export const CardContent = (props) => {
  return <StyledMUICardContent {...props} />;
};
